<template>
  <ion-app>
    <ion-tabs>
      <ion-menu side="start" menu-id="side" content-id="main">
        <ion-header>
          <ion-toolbar lines="none" translucent class="menu-toolbar">
            <ion-buttons slot="end" @click="closeMenu()">
              <div class="pl-05">
                <ion-icon :icon="closeOutline" size="large" />
              </div>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="menu-content">
          <h1 class="pl-30 c-white">{{appTitle}}</h1>
          <ion-list class="mt-20">
            <!-- <ion-item lines="none"  @click.stop="useExplorer ? menuNavigation('/explore') : menuNavigation('/matches') && changeTab('schedule')" class="pointer">
              <ion-icon :icon="homeSharp" slot="start"></ion-icon>
              <ion-label class="pl-10" size="large">HOME</ion-label>
            </ion-item> -->
            <!-- <ion-item lines="none" @click="menuNavigation('/teams')" class="pointer">
              <ion-icon :icon="appsSharp" slot="start"></ion-icon>
              <ion-label class="pl-10" size="large">TEAMS</ion-label>
            </ion-item> -->
            <ion-item lines="none" @click="menuNavigation(getTabHref('leaderboard')) && changeTab('leaderboard')" class="pointer">
              <ion-icon :icon="trophyOutline" slot="start"></ion-icon>
              <ion-label class="pl-10" size="large">LEADERBOARD</ion-label>
            </ion-item>
            <!-- <ion-item lines="none" class="pointer">
              <ion-icon :icon="peopleCircleSharp" slot="start"></ion-icon>
              <ion-label class="pl-10" size="large">MANAGER</ion-label>
            </ion-item> -->
          </ion-list>
        </ion-content>
      </ion-menu>
      <ion-router-outlet id="main" main class="ion-page"/>
      <ion-tab-bar slot="bottom" v-show="showTabBar">

        <ion-tab-button tab="explore" :href="getTabHref('explore')" @click.stop="changeTab('explore')" v-if="useExplorer" >
          <ion-icon :icon="calendar"></ion-icon>
          <ion-label>Explore</ion-label>

        </ion-tab-button>


        <ion-tab-button tab="schedule" :href="getTabHref('schedule')" @click.stop="changeTab('schedule')" v-if="!useExplorer">
          <ion-icon :icon="calendar"></ion-icon>
          <ion-label>Schedule</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="results" :href="getTabHref('results')" @click.stop="changeTab('results')" v-if="modules.quickResults">
          <ion-icon :icon="trophyOutline"></ion-icon>
          <ion-label>Results</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="search" :href="getTabHref('search')" @click.stop="changeTab('search')" >
          <ion-icon :icon="searchSharp"></ion-icon>
          <ion-label>Search</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="team" :href="getTabHref('teams')" @click.stop="changeTab('teams')" >
          <ion-icon :icon="personCircle"></ion-icon>
          <ion-label>Teams</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="ladder" :href="getTabHref('ladders')" @click.stop="changeTab('ladder')">
          <ion-icon :icon="podiumOutline"></ion-icon>
          <ion-label>Ladders</ion-label>
        </ion-tab-button>

 
      </ion-tab-bar>
    </ion-tabs>
  </ion-app>
</template>

<script>
import { 
  IonApp, 
  IonRouterOutlet,
  IonIcon, 
  IonLabel, 
  IonTabBar, 
  IonTabButton, 
  IonTabs,
  menuController
} from '@ionic/vue';
import { defineComponent } from 'vue';
import {
  calendar,
  personCircle,
  podiumOutline,
  menuSharp,
  appsSharp,
  homeSharp,
  peopleCircleSharp,
  closeOutline,
  searchSharp,
  trophyOutline,
} from 'ionicons/icons';


export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    IonIcon, 
    IonLabel, 
    // IonPage, 
    IonTabBar, 
    IonTabButton, 
    IonTabs
  },
  
  setup() {
    const beforeTabChange = () => {
      // do something before tab change
    }
    const afterTabChange = () => {
      // do something after tab change
    }

    return {
      calendar,
      personCircle,
      podiumOutline,
      menuSharp,
      appsSharp, 
      homeSharp, 
      peopleCircleSharp,
      closeOutline,
      searchSharp,
      trophyOutline,
      beforeTabChange,
      afterTabChange
    }
  },
  async mounted() {
    // const updateManifest = async () => {
    //   try {
    //     const url = new URL(window.location.href); 
    //     const pathnameParts = url.pathname.split('/').filter(Boolean); 

    //     const entityName = pathnameParts[2] || '';
    //     const site = `${url.origin}`;

    //     const clientName = process.env.VUE_APP_BANNER_TITLE ? process.env.VUE_APP_BANNER_TITLE : 'Assemble Sports';
    //     const name = entityName ? `Live Score - ${entityName.charAt(0).toUpperCase() + entityName.slice(1)}` : `Live Score - ${clientName}`;
    //     const startUrl = entityName ? `${site}/c/club/${entityName}` : `${site}/`
    //     const shortName = entityName ? `Live Score - ${entityName.charAt(0).toUpperCase() + entityName.slice(1)}` : 'Live Score';
    //     const myDynamicManifest = {
    //       "name": name,
    //       "short_name": shortName,
    //       "start_url": startUrl,
    //       "background_color": "#000000",
    //       "theme_color": "#000000",
    //       "display": "standalone",
    //       "icons": [
    //         {
    //           "src": `${site}/assets/icon/icon.png`,
    //           "sizes": "192x192",
    //           "type": "image/png",
    //           "purpose": "any"
    //         },
    //       ]
    //     }
    //     const stringManifest = JSON.stringify(myDynamicManifest);
    //     const blob = new Blob([stringManifest], {type: 'application/json'});
    //     const manifestURL = URL.createObjectURL(blob);
    //     document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);
    //   } catch (error) {
    //     console.error('Error fetching manifest:', error);
    //   }

    //   try {
    //     if ('serviceWorker' in navigator) {
    //       navigator.serviceWorker.register('/service-worker.js')
    //         .then(() => console.log("Service Worker Registered"));
    //     }
    //   } catch (error) {
    //     console.error('Error service worker:', error);
    //   }
    //     manifestLink.href = `http://192.168.9.111:3010/assemble/api/v1/live/nationals/manifest?entityType=${entityType}&entity=${entity}`;

    //   try {
    //     const pathName = window.location.pathname;
    //     console.log({
    //       location: window.location
    //     })
    //     console.log({
    //       pathName
    //     });
    //     const splitPath = pathName.split('/');
    //     console.log({
    //       splitPath
    //     });
    //     const isEntity = splitPath[1];
    //     const entityType = splitPath[2];
    //     const entity = splitPath[3];
    //     console.log({
    //       isEntity,
    //       entityType,
    //       entity
    //     });
    //     const manifestLink = document.createElement("link");
    //     manifestLink.rel = "manifest";
    //     manifestLink.id = "my-manifest-placeholder";
    //     if (isEntity === 'c' && entityType && entity) {
    //       console.log({
    //         isEntity,
    //         entityType,
    //         entity
    //       });
    //       manifestLink.href = 'http://192.168.9.111:3010/assemble/api/v1/live/nationals/manifest?entityType=' + entityType + '&entity=' + entity;
    //     } else {
    //       manifestLink.href = 'http://192.168.9.111:3010/assemble/api/v1/live/nationals/manifest';
    //     }
    //     // Append it to the <head> before other elements load
    //     document.head.appendChild(manifestLink);
    //   } catch (error) {
    //     console.error('Error apple setup:', error);
    //   }
    // };

    // updateManifest();

    await this.$store.dispatch('national/setup');
    const meta = this.$store.getters['national/getMeta'];
    console.log('meta', meta);
    if (meta) {
      document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
      document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
    } else {
      document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
      document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    }
    const { useExplorer } = this;
    if (useExplorer) {
      this.changeTab('explore');
    } else {
      console.log('change tab to schedule');
      this.changeTab('schedule');
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['matches/currentTab'];
    },
    modules() {
      return this.$store.getters['national/modules'];
    },
    appTitle() {
      return process.env.VUE_APP_BANNER_TITLE;
    },
    showTabBar() {
      return !this.$route.path.includes('matches') && !this.$route.path.includes('player');
    },
    useExplorer() {
      const settings = this.$store.getters['national/presentation'];
      return settings.useExplorer;
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },
  methods: {
    changeTab(tab) {
      this.$store.commit('matches/setCurrentTab', tab);
      // this.activeTab = tab;
    },
    getTabHref(tab) {
      console.log('getTabHref', tab);
      console.log('this.entity', this.entity);
      if (this.entity && this.entity._id) {
        if(tab === 'search') return `/c/${this.entity.level}/${this.entity.name}/${tab}`;
        if(tab === 'teams') return `/c/${this.entity.level}/${this.entity.name}/${tab}`;
        return `/c/${this.entity.level}/${this.entity.name}/tabs/${tab}`;
      } else {
        if(tab === 'search') return `/${tab}`;
        if(tab === 'teams') return `/${tab}`;
        if(tab === 'results') return `/results`;
        return `/tabs/${tab}`;
      }

    },
    menuNavigation(url){
      menuController.close("side");
      this.$router.push(url);
    },
    closeMenu() {
      menuController.close("side");
    },
  }
});
</script>

<style lang="scss">

  ion-icon {
    // stroke: white;
    // fill: white;
  }

  @media only screen and (min-width: 768px) {
    .ion-page {
      // margin: 1.5rem auto;
      border-radius: 1rem auto !important;
    }
  }

  .overlay {
    /* background: $primary; */
    background: $background;
    padding: 0rem;
  }

  ion-menu {
    --background: #03020d;
    --min-width: 100%;
  }

  ion-toolbar, ion-item {
    // --border-width: 0 !important;
    --background: $background;
    --color: white;
  }

  ion-tab-bar {
    --ion-color-primary: #fff;
    --background: rgba(0, 0, 0, 0.4);
    
    // Enhanced glassmorphism to match selection-container
    backdrop-filter: blur(30px) saturate(180%) !important;
    -webkit-backdrop-filter: blur(30px) saturate(180%) !important;
    
    // Subtle top shadow to lift from content
    box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2) !important;
    
    // Clean padding
    padding: 0.75rem 0 !important;
    padding-bottom: max(0.75rem, env(safe-area-inset-bottom, 0.75rem)) !important;
    
    // Smooth transitions
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    ion-tab-button {
      background: none;
      position: relative;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      // Enhanced interaction states
      &:hover {
        transform: translateY(-1px);
      }
      
      &:active {
        transform: translateY(0px);
      }
    }

    .active {
      transform: scale(1.1) translateY(-1px);
      border-radius: 12px;
      color: #4CAF50;
      
      // Subtle glow effect
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.5rem;
        height: 2.5rem;
        background: rgba(76, 175, 80, 0.1);
        border-radius: 12px;
        z-index: -1;
        transition: all 0.3s ease;
      }
      
      ion-label {
        font-weight: 600;
        color: white;
      }
    }
  }

  ion-title, ion-label {
    font-family: 'Cairo' !important;
  }

  ion-item {
    padding: 0.5rem 0;
    background: $background;
    // border-bottom: 1px solid #3a3a3a;
  }

  ion-list {
    background: $background;
    margin-inline: 1rem;
  }

  .menu-content {
    --background: $background !important;
  }

  .menu-title {
    font-family: 'Cairo';
  }

  .menu-toolbar {
    padding: 0.5rem;
  }
</style>